import { PAGE_HEADER_TEST_ID, QBS_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQBankStructureCreationModal } from '@exam-management/qbank-structure-creation';
import { QBankStructureList } from '@exam-management/qbank-structure-list';
import { AddRoundedIcon, Button, Flex, Paper, Text } from '@shared/components';
import { PermissionGuard, WithPermission } from '@shared/permissions';

export default function QBankStructuresPage() {
  const { createSection } = useQBankStructureCreationModal();

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
        APP_PERMISSIONS.QBANK.DASHBOARD.VIEW,
        APP_PERMISSIONS.QBANK.LOS.VIEW,
        APP_PERMISSIONS.QBANK.QUESTION.VIEW,
        APP_PERMISSIONS.QBANK.SETTING.VIEW,
        APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          width: '100%',
          height: '100dvh',
          bgcolor: (theme) => theme.palette.grey[50],
        }}
      >
        <Flex
          sx={(theme) => ({
            p: theme.spacing(8, 6),
            justifyContent: 'space-between',
            alignItems: 'center',
          })}
        >
          <Text variant='h1' data-testid={PAGE_HEADER_TEST_ID.TITLE_TEXT}>
            คลังข้อสอบ
          </Text>
          <WithPermission requiredPermission={APP_PERMISSIONS.QBANK.STRUCTURE.CREATE}>
            <Button
              size='large'
              startIcon={<AddRoundedIcon />}
              onClick={createSection}
              data-testid={QBS_DATA_TEST_ID.CREATE_BUTTON}
            >
              Create QBank
            </Button>
          </WithPermission>
        </Flex>
        <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1 }}>
          <Paper sx={{ width: '100%', borderRadius: (theme) => theme.shape.rounded(2) }}>
            <Flex
              sx={(theme) => ({
                flexDirection: 'column',
                height: '100%',
                gap: theme.spacing(6),
                p: theme.spacing(6),
              })}
            >
              <QBankStructureList />
            </Flex>
          </Paper>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
